import { render, staticRenderFns } from "./section2.vue?vue&type=template&id=b2c8189e"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports